import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'

type Props = {
  dataCy?: string
  label: string
  toggle: () => void
  open?: boolean
}

const OrderCardAccordionButton: FC<Props> = React.memo((props) => {
  const { dataCy, label, toggle, open } = props
  return (
    <button data-cy={`order-card-accordion-button-${dataCy}`} className={styles.order__accordion} onClick={toggle}>
      <span>{label}</span>
      <span className={open ? styles.order__accordion__arrow_open : styles.order__accordion__arrow} />
    </button>
  )
})

export default OrderCardAccordionButton
